module.exports = __webpack_public_path__ + "img/icon-clock-gray-light.abd97a41.svg";